import React, { useState } from 'react';

const Checkinpopup2 = (props) => {
    console.log('pppp', props);
    // const [locpopup, setLocpopup] = useState(false);

    const submit = (e) => {
        props.nextpage('checkinpopup3');
        // setLocpopup(true);
    };

    const submitHandler = () => {
        props.hideSlide();
        props.checkInHandler();
    }
    return (
        <>
            <div className="checkinpopup_bg">
                <div className='checkinpopup_content'>
                    <img src="/assets/images/crosspopup.svg" onClick={() => { props.hideSlide() }} className="close_check" alt="" />
                    <div className="checkinpopup_inner">
                        <ul className="swatch_list">
                            <li>
                                <img src="/assets/images/swatchbharat.png" alt="" />
                            </li>
                            <li>
                                <h5>{props.benName}</h5>
                            </li>
                        </ul>

                        <ul className="check_list">
                            <li>
                                <img src="/assets/images/check.svg" alt="" />
                            </li>
                            <li>
                                <h5>Please enable device location to check-in</h5>
                            </li>
                        </ul>
                        <div className="loc_en">
                            <img src="/assets/images/map.jpg" className="map_img" alt="" />
                            <div className="overlay_div"></div>
                            <a href="#" onClick={() => { props.submit(); }} className="enloc">How to enable Location <img src="/assets/images/arrowleft.svg" alt="" /></a>
                        </div>
                        <div className="next_btn checkin_btn">
                            <a href="#" onClick={() => { submitHandler() }}>Check-In</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* {locpopup && (
                <Checkinpopup3 hideSlide={hideSlide} />
            )} */}
        </>
    )
}
export default Checkinpopup2;